import VApp from './VApp'

export { VApp }
export default VApp



// WEBPACK FOOTER //
// webpack://Vuetify/src/components/VApp/index.js